import remainingChars from "surveylabJsAssets/page/_remaining-chars";

export default function  (){
    $('.sl-js-option-radio').on('change', function () {
        const $likertVerticalFreeOptionsElement = $(this).closest('.sl-js-likert-vertical-free-options-element');
        const $freeOptionInputs = $likertVerticalFreeOptionsElement.find('.sl-js-option-input');
        $freeOptionInputs.val('');

        if ($(this).hasClass('sl-js-free-option')) {
            const $freeOptionInput = $(this).parents('.sl-js-option-container').find('.sl-js-option-input').first();
            $freeOptionInput.trigger('focus');
        }
    });

    // On entering the free text field, select the corresponding radio button
    $('.sl-js-likert-vertical-free-options-element .sl-free-text').on('focusin', function () {
        const $optionContainer = $(this).closest('.sl-js-option-container');
        const $optionRadio = $optionContainer.find('.sl-js-option-radio');
        $optionRadio.prop("checked", true);
    });

    remainingChars.initOnce();
}